import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';


export interface NbGenreTimeframe {
  genre: number[];
  genres: string;
  suggested: number;
  suggested_period: string;
  suggested_str: string;
  missed: number;
  missed_period: string;
  missed_str: string;
}
export interface NbGenreTimeframesResponse {
  success: boolean;
  genres: NbGenreTimeframe[];
}

export interface NbGenreTimeframeResponse {
  success: boolean;
  genre: NbGenreTimeframe;
}

export interface NbGenreTimeframeSuccessResponse {
  success: boolean;
}

@Injectable()
export class GenretimeframeService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/genretimeframe/`;

  constructor(private http: HttpClient) {}

  public get(): Observable<NbGenreTimeframesResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}get`)
      .map(res => res as NbGenreTimeframesResponse);
  }


  public getGenretimeframeByPeriod(suggested: number, suggested_period: string,
    missed: number, missed_period: string): Observable<NbGenreTimeframeResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getgenretimeframe/suggested/${suggested}
      /suggested_period/${suggested_period}/missed/${missed}
      /missed_period/${missed_period}`)
      .map(res => res as NbGenreTimeframeResponse);
  }

  public save(genre: NbGenreTimeframe): Observable<NbGenreTimeframeSuccessResponse> {
    return this.http
      .post(`${this.API_ENDPOINT}save`, genre)
      .map(res => res as NbGenreTimeframeSuccessResponse);
  }

  public delete(suggested: number, suggested_period: string,
    missed: number, missed_period: string):
    Observable<NbGenreTimeframeSuccessResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}delete/suggested/${suggested}/
      suggested_period/${suggested_period}/missed/${missed}/
      missed_period/${missed_period}`)
      .map(res => res as NbGenreTimeframeSuccessResponse);
  }
}



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@core/data/genretimeframe.service.ts